import { reducer } from './data'
import {
    setProgress,
    setProgressMessage,
    languageChanged,
    steamChanged,
    setServerName,
    setClientVersion,
    setLauncherVersion,
    setUiVersion,
} from './actions'
import { getProgress } from './selectors'

// Reducer is exposed so that we can hook it up to the store creation
export const loadingBarReducer = reducer

// Middleware is exposed so that we can hook it up to the store creation
export { default as middleware } from './middleware'

// Actions are exposed as a way for the feature to recieve information
// The surrounding can send in data using these actions
export const actions = {
    setProgress, // Used by the Backend feature (ProgressManager)
    setProgressMessage, // Used by the Backend feature (ProgressManager)
    languageChanged, // Used by LanguageMiddleware
    steamChanged, // Used by SteamMiddleware
    setServerName, // Used by ServerMiddleware
    setClientVersion, // Used by VersionsMiddleware
    setLauncherVersion, // Used by VersionsMiddleware
    setUiVersion, // Used by VersionsMiddleware
}

// Selectors are exposed as a way for the surrounding to query the
// state from the feature
export const selectors = {
    getProgress, // Used by User & UserList containers
}



// WEBPACK FOOTER //
// ./src/features/LoadingBar/exports.js